import React from 'react';

import { CONTINUOUS_FEEDBACK_PEER_STATUS } from 'constants/ProjectConstants';

import { TextParseComponent } from 'uiToolkitV1/TextParseComponent';

// eslint-disable-next-line import/no-cycle
import { TextContainer, TruncatedTextBodyMedium } from '../constants/index';

const DescriptionText = ({ type, hideViewFullComment, ...props }) => {
  const { value } = props.data.requestDetails ?? props.data.comment ?? {};
  const { text, macros, peerStatus } = value ?? {};
  const isPendingType = type === 'PENDING';
  const isSharedType = type === 'SHARED';
  const isRequestedType = type === 'REQUESTED';
  const isReceivedType = type === 'RECEIVED';
  const isNominated = peerStatus === CONTINUOUS_FEEDBACK_PEER_STATUS.NOMINATED;
  const isAccepted = peerStatus === CONTINUOUS_FEEDBACK_PEER_STATUS?.ACCEPTED;

  if ((isReceivedType || isSharedType || isRequestedType) && !hideViewFullComment) {
    return (
      <TextContainer alignItems="center">
        <TruncatedTextBodyMedium>
          <TextParseComponent text={text} macros={macros} />
        </TruncatedTextBodyMedium>
      </TextContainer>
    );
  }

  if (isPendingType && isNominated) {
    return (
      <TextContainer alignItems="center">
        <TruncatedTextBodyMedium>
          <TextParseComponent text={text} macros={macros} />
        </TruncatedTextBodyMedium>
      </TextContainer>
    );
  }

  if (isPendingType && isAccepted) {
    return (
      <TextContainer alignItems="center">
        <TruncatedTextBodyMedium>
          <TextParseComponent text={text} macros={macros} />
        </TruncatedTextBodyMedium>
      </TextContainer>
    );
  }

  return (
    <TruncatedTextBodyMedium>
      <TextParseComponent text={text} macros={macros} />
    </TruncatedTextBodyMedium>
  );
};

export default DescriptionText;
